<template>
  <div>

    <div class="visual-reports-list-action-buttons mb-3">
      <div
          class="d-none d-sm-inline-block btn btn-sm btn-success shadow-sm"
          @click="openAddReportModal()"
      >
        <i class="fas fa-plus-circle me-1"/>
        Dodaj raport wizualny
      </div>
    </div>

    <div class="visual-reports-list-stage">
      <div class="visual-reports-list-table-container">
        <CommonTable2
            ref="visualReportsCommonTable"
            :table="tableData"
            rowIdentifier="guid"
            @onItemAction="runAction($event)"
            @onSort="sort($event)"
            @onMassAction="runMassAction($event)"
            @onCheckItem="checkAction($event)"
            :key="refreshTable"
            :currentPage="currentPage"
            :totalRows="visualReportsModule.getVisualReportsListTotal"
            :totalPages="visualReportsModule.getVisualReportsListPagesCount"
            :showPaginationTop="true"
            :showPaginationBottom="true"
            :multiselect="true"
            @onPageChange="currentPage = $event"
            :sortColumn="sortingKey"
            :sortDirection="sortingDirection"
            :showMassActions="true"
            :showRowActions="true"
            :showCheckboxColumn="true"
            :stickyScrollbarBottom="0"
        />
      </div>
    </div>

    <!-- Visual Reports Form Modal -->
    <VisualReportsFormModal
        v-if="showFormModal"
        v-model:showModal="showFormModal"
        :title="formModalTitle"
        :reportGuid="editReportGuid"
        @onSave="onReportSaved()"
        @onCreated="onReportCreated($event)"
        @onClose="showFormModal = false"
    />

  </div>
</template>

<script>
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import VisualReportsFormModal from "@/views/ReportsManager/VisualReportsFormModal.vue";
import {log} from "@/state/pinia/log";
import {useVisualReportsModule} from "@/state/pinia/visualReportsModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import Swal from "sweetalert2";

export default {
  name: "VisualReportsListView",
  components: {
    CommonTable2,
    VisualReportsFormModal,
  },
  data() {
    return {
      tableData: {},
      currentPage: 1,
      sortingDirection: "DESC",
      sortingKey: "updatedAt",
      refreshTable: true,

      // Modals
      showFormModal: false,
      formModalTitle: "Dodaj raport wizualny",
      editReportGuid: null,

      availableHeaders: [
        {
          text: "Nazwa",
          key: "name",
          type: "text",
          sortable: true,
          width: "220px",
        },
        {
          text: "Opis",
          key: "description",
          type: "text",
          sortable: false,
          width: "260px",
        },
        {
          text: "Typ raportu",
          key: "reportType",
          type: "text",
          sortable: true,
          width: "180px",
        },
        {
          text: "Data aktualizacji",
          key: "updatedAt",
          type: "date",
          isEpochMillis: true,
          sortable: true,
          width: "160px",
        },
        {
          text: "Akcje",
          key: "actions",
          type: "actions",
          width: "180px",
          actions: [],
        },
      ],
    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    visualReportsModule() {
      return useVisualReportsModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
  },
  methods: {
    sort(sortKey) {
      log.log(sortKey);
      this.sortingKey = sortKey;
      this.toggleSortingDirection();
      this.refreshList();
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },
    checkAction(event) {
      log.log(event);
    },
    runAction(event) {
      const action = event.action.action;
      const item = event.itemData;
      log.log("runAction:", action, item);

      if (action === "view-report-instance") {
        this.openVisualization(item.guid);
      } else if (action === "edit-report-instance") {
        this.openEditReportModal(item.guid);
      } else if (action === "delete-report-instance") {
        this.deleteReport(item.guid, item.name);
      }
    },
    runMassAction(event) {
      log.log(event);
    },

    openAddReportModal() {
      this.editReportGuid = null;
      this.formModalTitle = "Dodaj nowy raport wizualny";
      this.showFormModal = true;
    },
    openEditReportModal(reportGuid) {
      this.editReportGuid = reportGuid;
      this.formModalTitle = "Edytuj raport wizualny";
      this.showFormModal = true;
    },

    onReportSaved() {
      this.showFormModal = false;
      this.refreshList();
    },
    onReportCreated(createdReport) {
      log.log("onReportCreated:", createdReport);
      if (createdReport && createdReport.guid) {
        this.$router.push({
          name: "VisualReportVisualization",
          params: { guid: createdReport.guid },
        });
      }
    },

    openVisualization(reportGuid) {
      this.$router.push({
        name: "VisualReportVisualization",
        params: { guid: reportGuid },
      });
    },

    deleteReport(reportGuid, name) {
      Swal.fire({
        title: "Usunąć raport?",
        text: "Czy na pewno usunąć raport wizualny \"" + name + "\"? Operacja jest nieodwracalna!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        cancelButtonText: "Nie",
        confirmButtonText: "Tak, usuń",
        customClass: { container: "swal-highest" },
        dangerMode: true,
      }).then((result) => {
        if (result.value) {
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.lazyloaderModule.setProgressBarMessage("Usuwanie raportu wizualnego...");
          this.visualReportsModule.httpDeleteVisualReport(reportGuid, name).then(() => {
            this.refreshList();
          }).catch(() => {
            this.lazyloaderModule.setDisplayLazyLoader(false);
            this.lazyloaderModule.setProgressBarMessage("");
          });
        }
      });
    },

    buildTableData() {
      const list = JSON.parse(JSON.stringify(this.visualReportsModule.getVisualReportsList));

      const rows = list.map((item) => {
        const row = Object.assign({}, item);
        row.actions = [
          {
            icon: "fas fa-chart-bar",
            action: "view-report-instance",
            enabled: true,
            tooltip: "Otwórz wizualizację raportu",
            class: "btn btn-success btn-sm table-actions-button",
          },
          {
            icon: "fas fa-edit",
            action: "edit-report-instance",
            enabled: true,
            tooltip: "Edytuj dane raportu",
            class: "btn btn-info btn-sm table-actions-button",
          },
          {
            icon: "fas fa-trash",
            action: "delete-report-instance",
            enabled: true,
            tooltip: "Usuń raport",
            class: "btn btn-danger btn-sm table-actions-button",
          },
        ];
        return row;
      });

      this.tableData = {
        headers: this.availableHeaders,
        massActions: [],
        data: rows,
      };
    },

    refreshList() {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.lazyloaderModule.setProgressBarMessage("Pobieranie listy raportów wizualnych...");
      this.visualReportsModule.setVisualReportsList([]);
      this.refreshTable = false;

      this.visualReportsModule.httpGetVisualReportsPaging({
        page: this.currentPage,
        size: 20,
      }).then(() => {
        this.buildTableData();
        this.refreshTable = true;
      });
    },
  },
  watch: {
    currentPage: {
      handler() {
        this.refreshList();
      },
      deep: true,
    },
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetWorkingProfile().then(() => {
        this.refreshList();
      });
    });
  },
};
</script>
